import { Anchor, Breadcrumbs, Card, Grid } from '@mantine/core';
import { useParams } from 'react-router';
import Metadata from '../../components/Metadata';
import SyncSegmentsNewForm from '../../components/SyncSegments/SyncSegmentsNewForm';
import { Page } from '../../constants/pageTitles';

const page = `${Page['syncSegments']}`;

const SyncSegmentsNewPage = () => {
  const { accountId, domainId } = useParams();

  const breadcrumbItems = [
    { title: page, href: `#/accounts/${accountId}/domains/${domainId}/syncSegments` },
    { title: 'New' },
  ].map((item, index) => (
    <Anchor href={item.href} key={index}>
      {item.title}
    </Anchor>
  ));

  return (
    <>
      <Metadata title={`${page} | New`} />
      <Breadcrumbs mb="md">{breadcrumbItems}</Breadcrumbs>
      <Grid>
        <Grid.Col span={12}>
          <Card withBorder>
            <SyncSegmentsNewForm />
          </Card>
        </Grid.Col>
      </Grid>
    </>
  );
};

export default SyncSegmentsNewPage;
